import React, {useState, useEffect} from 'react';
import {TituloMenu,ColFlex, RowStyle, DivPedidoContenido} from './style'
import {Row, Col, List, Card, Button, Modal,Drawer} from 'antd'
import FormAgregarProducto from './forms/FormAgregarProducto';
import useWindowSize from '../../assets/js/use-windows-size';
import { useSelector, useDispatch } from 'react-redux';
import { actionGetCatalogo, actionAgregarProductoCatalogo, actionEditarProducto } from '../../store/acciones/accionesCatalogo';
import FormEditarProducto from './forms/FormEditarProducto';


const Catalogo = () => {
const size = useWindowSize();
const [visible, showModal] = useState(false)
const [visibleSider, showSider] = useState(false)
const [producto, getProducto]=useState({})
const [isMobile, windowResize] = useState(false)

//Se obtienen los clientes  del servidor
let catalogo = useSelector(state => state.reducerCatalogo.catalogo);
const dispatch = useDispatch();


useEffect(() => {
    dispatch(actionGetCatalogo())
    windowResize({ isMobile: size.width <= 360 ? true : false })
}, [dispatch, size.width])



const AgregarProducto = (values) => {
    setTimeout(() => {
        dispatch(actionAgregarProductoCatalogo(values))
        showModal(false)
    }, 500);
}

const OpenFormCatalogo = (producto) => {
    getProducto(producto)
    showSider(true)
}

const EditarProducto = (values) => {
    dispatch(actionEditarProducto(producto.id, values))
    setTimeout(() => {
        showSider(false)
    }, 500);
}
  
    return (
        <>
            <TituloMenu>Catalogo</TituloMenu>
            <RowStyle type="flex" justify="space-around" align="middle">
                {/* <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Search placeholder="Numero de orden, cliente " onSearch={value => console.log(value)} enterButton />
                </ColFlex> */}
                <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                    <div>
                        <Button type="primary" icon="plus" size="default" onClick={()=>showModal(true)}>
                            Agregar Producto
                        </Button>
                        <Modal
                            title="Agregar Producto"
                            visible={visible}
                            onOk={()=>showModal(false)}
                            onCancel={()=>showModal(false)}
                            footer={false}
                        >
                            <FormAgregarProducto registro={AgregarProducto}/>
                        </Modal>
                    </div>
                </ColFlex>
            </RowStyle>

            <Row type="flex" justify="space-around" align="middle">
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <List
                     pagination={{
                        pageSize: 10,
                      }}
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 1,
                            md: 1,
                            lg: 1,
                            xl: 1,
                            xxl: 1,
                        }}
                        dataSource={catalogo}
                        renderItem={item => (
                            <List.Item>
                                <Card title={item.cliente} >
                                    <Row type="flex" justify="space-around" align="middle">
                                        <Col xl={20} lg={20} md={24} sm={24} xs={24}>
                                            <DivPedidoContenido>
                                                <p>Nombre del producto: <span>{item.titulo}</span></p> 
                                                <p>Categoria: <span>{item.categorias.categoria}</span></p>
                                                <p>Caracteristicas: <span>{item.descripcion}</span></p>
                                            </DivPedidoContenido>
                                        </Col>
                                      
                                        <Col l={4} lg={4} md={24}  sm={24} xs={24} >
                                                {/* <Button>Descargar PDF</Button> */}
                                                <Button  icon="edit" onClick={() => OpenFormCatalogo(item)} >Editar</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </List.Item>
                        )}
                    />

                    <Drawer
                        title="Editar Producto"
                        placement="right"
                        closable={false}
                        onClose={() => showSider(false)}
                        visible={visibleSider}
                        width={isMobile.isMobile ? "90%" : "40%"}
                        destroyOnClose
                    >
                        <FormEditarProducto registro={EditarProducto}  data={producto}/>
                    </Drawer>
                </Col>
            </Row>
        </>
    );
};

export default Catalogo;